import { render, staticRenderFns } from "./BuyOrders.vue?vue&type=template&id=e8af2e82&"
import script from "./BuyOrders.vue?vue&type=script&lang=js&"
export * from "./BuyOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports